import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { VULNERABILITY_METHODS_CONFIG } from "../../config/VulnerabilityMethods.config";
import { Method } from "../../types/interfaces/methods";

export const useCaptureVulnerability = (captureIdStr?: string, method?: Method) => {
  const queryClient = useQueryClient();
  const captureId = Number(captureIdStr);

  const config = VULNERABILITY_METHODS_CONFIG.find((m) => m.method === method);

  const queryKey = ["capture", captureId, "vulnerability", method];

  const result = useQuery({
    queryKey,
    queryFn: () => config!.getResults(captureId),
    enabled: !!captureId && !!method && !!config,
  });

  const calculateMutation = useMutation({
    mutationFn: (values: any) => config!.calculate(captureId, values),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey });
    },
  });

  return {
    resultsData: result.data ?? [],
    isPending: result.isPending,
    isError: result.isError,
    error: result.error,
    calculate: calculateMutation.mutateAsync,
    isCalculating: calculateMutation.isPending,
  };
};
